import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import http from "@/api";
import { RECOGNITION_META, toBase10 } from "@/constants";
import { AlertTriangle } from "lucide-react";

export default function DevelopmentWarnings() {
  const [data, setData] = useState(null);

  useEffect(() => {
    http.get("/recognition/summary").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const list = data.requiere_desarrollo || [];
  const counts = data.counts || {};

  return (
    <div className="sketch-border bg-[var(--cream-soft)] p-6 mb-10" data-testid="development-warnings">
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <div className="font-hand text-xl text-[var(--lala-blue)]">reconocimiento · {data.period}</div>
          <h3 className="font-display text-2xl">Alertas de desarrollo</h3>
        </div>
        <div className="flex gap-2 flex-wrap">
          {["requiere_desarrollo", "bronce", "plata", "oro", "platino"].map((k) => (
            <span key={k} className="sketch-pill px-2.5 py-1 text-xs font-bold text-white"
              style={{ background: RECOGNITION_META[k].color }} data-testid={`recognition-count-${k}`}>
              {(data.labels?.[k] || RECOGNITION_META[k].label).replace("LALA Elite ", "")}: {counts[k] ?? 0}
            </span>
          ))}
        </div>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-[var(--ink-soft)] mt-3" data-testid="development-warnings-empty">
          Ningún proveedor con capturas requiere plan de desarrollo este periodo. {counts.sin_datos > 0 && `(${counts.sin_datos} sin datos capturados aún.)`}
        </p>
      ) : (
        <>
          <p className="text-sm text-[#8F0E1D] font-semibold mt-3 flex items-center gap-1.5">
            <AlertTriangle size={14} /> {list.length} proveedor(es) requieren plan de desarrollo:
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-2">
            {list.slice(0, 12).map((s) => (
              <Link key={s.supplier_id} to={`/proveedores/${s.supplier_id}`}
                className="p-3 rounded-lg bg-[#FDEBEE] border border-[#E0162B]/40 hover:border-[#E0162B] transition-colors"
                data-testid={`dev-warning-${s.supplier_id}`}>
                <div className="text-sm font-bold text-[#8F0E1D] truncate">{s.name}</div>
                <div className="text-xs text-[var(--ink-soft)]">{s.category} · promedio {toBase10(s.average)?.toFixed(1) ?? "—"} / 10</div>
              </Link>
            ))}
          </div>
          {list.length > 12 && <div className="text-xs text-[var(--ink-soft)] mt-2">…y {list.length - 12} más.</div>}
        </>
      )}
    </div>
  );
}
